export const getDescriptionText = (html: string) => {
    const doc = new DOMParser().parseFromString(html || '', 'text/html');
    return doc.body.textContent?.trim() ?? '';
};

export const getFeedbackSuccessMessage = (response: any) => {
    return (
        response?.data?.message ||
        response?.data?.detail ||
        'Feedback submitted successfully!'
    );
};

export const getFeedbackErrorMessage = (error: any) => {
    return (
        error?.response?.data?.detail ||
        error?.response?.data?.message ||
        error?.message ||
        'Failed to submit feedback.'
    );
};
